
import React, { useEffect, useState, useRef } from 'react';
import { Box, Card, Divider, TableBody, Typography, ListItemText, TextareaAutosize, Chip } from '@mui/material';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { MenuItem } from "@mui/material";
import Select from "@mui/material/Select";
import FormControl from '@mui/material/FormControl';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Paginator from "../../../toolkit/Paginator";

import axios from '../../../utils/fvAxios';
import { Autocomplete, } from '@mui/material';

import Status from "../../../stories/StatusComponent/StatusComponent";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton';

import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import Trash from "../../../icons/trash1.svg";
import Replay from "../../../icons/Replay.svg";
import GetfVDateFormate from '../../../utils/Genaricfunctions';
import { ToastContainer, toast } from 'react-toastify';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import CloseIcon from '@mui/icons-material/Close';
import _debounce from 'lodash/debounce';
import { getOrgType } from '../../../utils/Token';


export default function VendorsInvited() {

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: theme.palette.action.hover,

        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 14,
        },
        // hide last border
        '&:last-child td, &:last-child th': {
            border: 0,
            marginBottom: "20px"
        },
    }));
    const menuListRef = useRef(null);
    const scrollToTopOfOtions = () => {
        setTimeout(() => {
            if (menuListRef.current) {
                const children = menuListRef.current.children;
                if (children.length >= 2) {
                    const secondLastOption = children[children.length - 2];
                    if (secondLastOption) {
                        secondLastOption.scrollTop = 0;
                    }
                }
            }
        }, 5);
    };
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: 50 * 5 + 8,
                width: "320px",
            },

        },
    };
    const handleMenuOpen = () => {
        scrollToTopOfOtions();
    };
    const toastNotify = (message, isSuccess = true) => {
        if (isSuccess) {
            toast.success(message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        } else {
            toast.error(message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    };

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const COLOR = [
        {
            "key": 3,
            "text": "#12B76A"
        }, {
            "key": 1,
            "text": "#ED8A17"
        },
        {
            "key": 2,
            "text": "#667085"
        }
    ]
    const TEXT = [
        {
            "key": 3,
            "text": "New"
        }, {
            "key": 1,
            "text": "Expired"
        },
        {
            "key": 2,
            "text": "Outside Network"
        }
    ]


    const [spinner, setSpinner] = React.useState(false);

    const [InvitationId, setInvitationId] = React.useState("");
    const [Tab, setTab] = React.useState("");
    const [InvitedVendors, setInvitedVendors] = React.useState([]);
    const [VendorCompanyName, setVendorCompanyName] = React.useState("");


    const [Count, setCount] = useState("");
    const [number, setNumber] = useState("1");
    const [state, setState] = React.useState(false);
    const [Comment, setComment] = React.useState("");
    const [Search, setSearch] = useState("");

    const [clientList, setClientList] = React.useState([]);
    const [clientId, setClientId] = React.useState("");
    const [ClientUsersList, setClientUsersList] = React.useState([]);
    const [ClientUsersListIds, setClientUsersListIds] = React.useState([]);
    const [Save, setSave] = React.useState(false);

    // const [NewVendor, seNewVendor] = useState(false);
    // const [OutsideNetwork, setOutsideNetwork] = useState(false);
    // const [ExpiredVendor, setExpiredVendor] = useState(false);

    const [dialogopen, setDialogOpen] = React.useState(false);
    const [SendNotifocation, setSendNotifocation] = React.useState([]);

    const [BHOpen, setBHOpen] = useState(false);

    const DialogOpenClick = (val, r) => {
        setTab(val);
        setVendorCompanyName(val == 1 || val == 2 ? r?.vendorCompanyName : "");
        setInvitationId(val == 1 || val == 2 ? r?.invitationId : "");
        setDialogOpen(true);
    };
    const DialogCloseClick = () => {
        setDialogOpen(false);
    };

    const toggleDrawer = (open) => () => {
        setState(open);
    };



    useEffect(() => {
        Details();
    }, [number, Save]);

    // useEffect(() => {
    //     if (Search?.length > 3 || Search == "")
    //         Details();
    //     setNumber("1");
    // }, [Search]);

    const debouncedDetails = _debounce(() => {
        Details();
        setNumber("1");
    }, 1000);

    useEffect(() => {
        debouncedDetails();
        return () => debouncedDetails.cancel();
    }, [Search]);

    useEffect(() => {
        Getclients();
    }, []);

    const SpinnerClose = () => {
        setSpinner(false);
    };


    async function Getclients() {
        const res = await axios.get("Prequalification/GetAllClients?getAll=false&isIncludeMultiClient=false");
        setClientList(res?.data?.data);
       // ChangeClient(res?.data?.data[0]?.value);

    }

    const ChangeClient = async (i) => {
        setClientId(i);
        const res = await axios.get("SystemUser/GetClientUserDetailsIncludingFirstAdmin?ClientId=" + i);
        setClientUsersList(res?.data?.data);
        setClientUsersListIds([]);
    }
    const handlePageChange = (e) => {
        setNumber(e);
    };


    // const SendNotificationTo = (val, ans) => {
    //     if (!val) {
    //         setSendNotifocation(preNotifications => {
    //             const newNotif = [...preNotifications];
    //             newNotif.splice(preNotifications.indexOf(ans));
    //             return newNotif;
    //         });
    //     } else {
    //         setSendNotifocation(preNotifications => {
    //             return [...preNotifications, ans];
    //         }
    //         );
    //     }
    // }


    const SendNotificationTo = (val, ans, setSendNotification) => {
        setSendNotification(preNotifications => {
            if (!val) {
                // If val is false (unchecked), remove the specific 'ans' value from the state.

                return preNotifications.filter(item => item !== ans);
            } else {
                // If val is true (checked), add the 'ans' value to the state if it's not already present.
                if (!preNotifications.includes(ans)) {

                    return [...preNotifications, ans];
                } else {
                    return preNotifications; // No change if 'ans' is already in the state.
                }
            }
        });
    };




    async function Details() {
        setSpinner(!spinner);
        const INVITED = ClientUsersListIds ? ClientUsersListIds : [null];
        console.log(ClientUsersListIds);

        const INVITATIONTYPE = SendNotifocation?.toString();
        let data = {
            "pageNumber": number,
            "pageSize": 12,
            "searchEmail": Search,
            "invitationType": INVITATIONTYPE,
            "clientId": clientId ? clientId : 0,
            "invitedBy": INVITED
        };
        axios.post("AdminVendors/GetInvitedVendors", data)
            .then((res) => {
                setInvitedVendors(res?.data?.data?.invitedVendors?.vendors);
                setCount(res?.data?.data?.invitedVendors?.count);
                // setState(false);
            }).catch(err => {
                console.log(err);
            }).finally(() => {
                setSpinner(false);
            })
    }
    const Send = async () => {

        if (Tab == 1) {
            if (Comment != "") {
                setBHOpen(true);
                axios.post("Companies/UpdateInvitationComments?invitationId=" + InvitationId + "&comments=" + Comment)
                    .then((res) => {
                        if (res?.data?.responseCode == 100) {
                            setBHOpen(false);
                            toastNotify(res?.data?.data, true);
                            DialogCloseClick();
                            setComment("");
                            Details();
                        } else {
                            toastNotify(res?.data?.responseMessage, false);
                            setDialogOpen(true);
                            setBHOpen(false);
                        }
                    }).catch(err => {
                        console.log(err);
                    }).finally(() => {
                        setBHOpen(false);
                    })

            } else {
                toastNotify("Please Enter mandatory fields", false);

            }
        } else {
            const res = await axios.post("Companies/RemoveVendorfromVendorsInvited?invitationId=" + InvitationId);
            if (res?.data?.responseCode == 100) {
                toastNotify(res?.data?.data, true);
                DialogCloseClick();
                Details();
            } else {
                toastNotify(res?.data?.responseMessage, false);
                setDialogOpen(true);
            }
        }

    }
    const Clear = () => {
        setNumber(1);
        //setState(false);
        setClientId("");
        // ChangeClient("");
        setSendNotifocation([]);
        setClientUsersList([]);
        // seNewVendor(false);
        // setOutsideNetwork(false);
        // setExpiredVendor(false);
        setClientUsersListIds([]);
        setSave(!Save);
    }

    return (
        <Box sx={{ width: "100%" }}>
            <ToastContainer />
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={spinner}
                onClick={SpinnerClose}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <Dialog

                open={dialogopen}
                onClose={DialogCloseClick}
                aria-labelledby="draggable-dialog-title"
            >
                <Stack direction={"row"} spacing="Auto">

                    <div className='text-center' style={{ justifyContent: 'center', display: "flex" }}>
                        <DialogTitle style={{ cursor: 'move', }} id="draggable-dialog-title">
                            <p style={{ width: "250px", justifyContent: 'center' }}>{VendorCompanyName}</p>
                        </DialogTitle>

                    </div>
                    <Button color="error" onClick={DialogCloseClick} sx={{ textTransform: "capitalize" }}><CloseIcon /></Button>
                </Stack>
                <DialogContent sx={{

                }}>
                    <DialogContentText style={{ justifyContent: 'center' }}>
                        {Tab == 1 ?
                            <div className='' >
                                <span style={{ color: "#3E4A62" }}>Comments <span style={{ color: "red" }}>*</span></span>
                                <br />
                                <TextareaAutosize
                                    minRows={3}
                                    id="Comments"
                                    name="Comments"
                                    placeholder="Comments"
                                    className="form-control text-feild-custom "
                                    size='small'
                                    value={Comment || ""}
                                    onChange={(e) => setComment(e.target.value)}
                                    style={{ width: "330px" }}
                                />
                            </div>

                            : <span style={{ textAlign: "center" }}>Are you sure you want to delete?</span>}

                    </DialogContentText>
                </DialogContent>
                <DialogActions style={{ justifyContent: 'center', marginBottom: "5px" }}>
                    <Button variant="outlined" color="primary" style={{ backgroundColor: '#DBEAF4', padding: "20px", width: "120px" }} onClick={() => {
                        DialogCloseClick()
                        setComment("")
                    }}>Cancel </Button>
                    <Button disabled={BHOpen == true} variant="contained" style={{ padding: "20px", width: "120px" }} onClick={Send}>Save </Button>
                </DialogActions>
            </Dialog>


            <SwipeableDrawer
                anchor={"right"}
                open={state}
                onClose={toggleDrawer(false)}
                onOpen={toggleDrawer(true)}
            >
                <div>
                    <div style={{ padding: "10px" }}>
                        <Stack direction={"row"} spacing="Auto">
                            <span className='mx-3' style={{ fontSize: "large", fontWeight: "bold" }}>Vendors Invited Filters</span>
                            <Button color="error" onClick={() => setState(false)} sx={{ textTransform: "capitalize" }}><CloseIcon /></Button>
                        </Stack>
                        <Divider sx={{ marginTop: 2, backgroundColor: "#667085;", height: "2px" }} />
                    </div>
                    <div style={{ padding: "10px" }}>
                        <div className='mt-3' >
                            <span className='mb-3 mx-3' style={{ color: "#3E4A62" }}>Status</span>
                            <br />

                            <FormControl className="mx-4" sx={{ marginLeft: "10px" }}>
                                <FormControlLabel value={"3"} className="mb-2" control={<Checkbox checked={SendNotifocation?.includes("3")} onClick={(e) => SendNotificationTo(e.target.checked, "3", setSendNotifocation)} />} label="New Vendor" />
                                <FormControlLabel value={"1"} className="mb-2" control={<Checkbox checked={SendNotifocation?.includes("1")} onClick={(e) => SendNotificationTo(e.target.checked, "1", setSendNotifocation)} />} label="Expired Vendor" />
                                <FormControlLabel value={"2"} className="mb-2" control={<Checkbox checked={SendNotifocation?.includes("2")} onClick={(e) => SendNotificationTo(e.target.checked, "2", setSendNotifocation)} />} label="Outside Network" />
                            </FormControl>
                        </div>
                        <div className='mt-3 mx-3' >
                            <span style={{ color: "#3E4A62" }}>
                                {getOrgType() == "Client" ? "Client" : "Clients"}
                            </span>
                            <br />
                            <Select
                                sx={{
                                    '& legend': { display: 'none' },
                                    '& fieldset': { top: 0 },
                                    width: "320px"
                                }}
                                labelId="demo-multiple-name-label"
                                value={clientId || ""}
                                id="demo-multiple-name"
                                size="small"
                                onChange={(e) => ChangeClient(e.target.value, "")}
                                MenuProps={MenuProps}
                            >
                                {clientList?.map((r, i) =>
                                    <MenuItem key={i} title={r?.text} value={r?.value} > {r?.text}</MenuItem>
                                )}
                            </Select>
                        </div>

                        <div className='mt-3 mx-3' >
                            <span style={{ color: "#3E4A62" }}>Invited by</span>
                            <br />
                            <Select
                                onOpen={handleMenuOpen}
                                labelId="docs-label"
                                id="docs-select"
                                multiple
                                size='small'
                                sx={{ width: "320px", overflow: "hidden" }}
                                name="Site Safety Representive"
                                value={ClientUsersListIds || []}
                                MenuProps={{
                                    ref: menuListRef,
                                    PaperProps: MenuProps.PaperProps,
                                }}
                                renderValue={(selected) =>
                                    selected
                                        .map((key) => ClientUsersList?.find((doc) => doc?.userId === key)?.name)
                                        .filter((value) => value !== undefined)
                                        .join(", ")
                                }
                                onChange={(e) => setClientUsersListIds(e.target.value)}
                            >
                                <MenuItem key="Select All" hidden={ClientUsersList?.length == 0}>
                                    <Checkbox
                                        id="select-all-checkbox"
                                        indeterminate={
                                            ClientUsersListIds?.length > 0 && ClientUsersListIds?.length < ClientUsersList?.length
                                        }
                                        checked={ClientUsersListIds?.length === ClientUsersList?.length}
                                        onChange={(event) => {
                                            if (event?.target?.checked) {
                                                setClientUsersListIds(ClientUsersList?.map((doc) => doc?.userId));
                                                scrollToTopOfOtions();
                                            } else {
                                                setClientUsersListIds([]);
                                            }
                                        }}
                                    />
                                    <label htmlFor="select-all-checkbox" style={{ fontSize: "16px", fontWeight: "500", color: "rgba(0, 0, 0, 0.87)", width: "320px", cursor: "pointer" }}>
                                        Select All
                                    </label>
                                </MenuItem>

                                {ClientUsersList?.map((r, i) => (
                                    <MenuItem key={r?.userId} value={r?.userId}>
                                        <Checkbox checked={ClientUsersListIds?.indexOf(r?.userId) > -1} />
                                        <ListItemText primary={r?.name} />
                                    </MenuItem>
                                ))}
                            </Select>


                            {/* <Select
                                labelId="docs-label"
                                id="docs-select"
                                multiple
                                size='small'
                                sx={{ width: "320px", overflow: "hidden" }}
                                name="Clayco Bidding Interests"
                                value={ClientUsersListIds || []}
                                MenuProps={MenuProps}
                                renderValue={(selected) =>
                                    selected
                                        .map((key) => ClientUsersList?.find((doc) => doc?.userId === key)?.name)
                                        .filter((value) => value !== undefined)
                                        .join(", ")
                                }
                                onChange={(e) => setClientUsersListIds(e.target.value)}
                            >
                                {ClientUsersList?.map((r) => (
                                    <MenuItem key={r?.userId} value={r?.userId}>
                                        <Checkbox checked={ClientUsersListIds?.indexOf(r?.userId) > -1} />
                                        <ListItemText primary={r?.name} />
                                    </MenuItem>
                                ))}
                            </Select> */}
                        </div>

                        <div className="login-help__buttonContainer mt-4 mx-2">
                            <Button variant="contained" className="login-help-button-cancel mx-2" sx={{ textTransform: "capitalize" }} onClick={Clear}> Clear Filters</Button>
                            <Button variant="contained" className="mx-2  mt-2" sx={{ padding: "20px", width: "140px", textTransform: "capitalize" }}
                                onClick={() => {
                                    setSave(!Save)
                                    setNumber(1)
                                    setState(false)
                                }}> Apply Filters</Button>
                        </div>
                    </div >


                </div>
            </SwipeableDrawer>

            <Card>
                <div style={{ marginLeft: "10px", marginTop: "10px" }}>
                    <Stack spacing={2} direction="row">
                        <div style={{ marginLeft: "5px" }}>
                            <TextField
                                placeholder='Search'
                                sx={{
                                    "& legend": { display: "none" },
                                    "& fieldset": { top: 0 },
                                    fontFamily: "Arial, FontAwesome"
                                }}
                                variant="outlined"
                                size="small"
                                value={Search || ""}
                                onChange={(e) => setSearch(e?.target?.value)}
                            />
                        </div>
                        <div style={{ marginLeft: "Auto", padding: "10px" }}>
                            <Button variant="outlined" sx={{ padding: "12px", textTransform: "capitalize" }} onClick={toggleDrawer(true)} >Filters</Button>
                        </div>
                    </Stack >
                </div>
                <Box sx={{ backgroundColor: '#f8f9fa' }}>
                    <>
                        {InvitedVendors?.length < 1 ?
                            <div hidden={spinner}>
                                <Box border={1} borderLeft={1} borderRight={1} borderColor="#e4e7ec" sx={{ padding: 2, marginTop: 2, marginRight: "13px", width: "100%" }} className="text-center">
                                    <span style={{ color: "#667085" }}>No Records found</span>
                                </Box>
                            </div> :
                            <>
                                <TableContainer component={Paper} sx={{ borderBottom: 0 }}>
                                    <Table aria-label="customized table">

                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell ><span style={{ color: "#667085", fontSize: "16px" }}> Vendor Name	</span></StyledTableCell>
                                                <StyledTableCell ><span style={{ color: "#667085", fontSize: "16px" }}> Vendor Type</span></StyledTableCell>
                                                <StyledTableCell ><span style={{ color: "#667085", fontSize: "16px" }}> Date</span></StyledTableCell>
                                                <StyledTableCell ><span style={{ color: "#667085", fontSize: "16px" }}> Invited By</span></StyledTableCell>
                                                <StyledTableCell >&nbsp;</StyledTableCell>
                                                <StyledTableCell >&nbsp;</StyledTableCell>

                                            </TableRow>
                                        </TableHead>


                                        {InvitedVendors?.map((r, i) => (
                                            <TableBody key={i}>

                                                <TableRow key={i}>

                                                    <StyledTableCell sx={{ width: "30%" }}>
                                                        <span style={{ fontWeight: "bold" }}>{r?.vendorCompanyName}</span>
                                                        <br />
                                                        <span className='text-muted'>  {r?.emailAddress}</span>
                                                    </StyledTableCell>
                                                    <StyledTableCell sx={{ width: "25%" }}>
                                                        <Chip
                                                            //color={COLOR?.find((p) => p?.key == r?.invitationType)?.text}
                                                            label={TEXT?.find((p) => p?.key == r?.invitationType)?.text}
                                                            sx={{
                                                                borderRadius: "3px",
                                                                backgroundColor: COLOR?.find((p) => p?.key == r?.invitationType)?.text,
                                                                color: "#FFFFFF",
                                                                width: "Auto",
                                                                height: "24px",
                                                            }}
                                                        />
                                                    </StyledTableCell>
                                                    <StyledTableCell sx={{ width: "25%" }}>
                                                        {GetfVDateFormate(r?.invitationDate)}
                                                    </StyledTableCell>
                                                    <StyledTableCell sx={{ width: "25%" }} >
                                                        {r?.fullName}
                                                    </StyledTableCell>
                                                    <StyledTableCell sx={{ width: "10%" }}>
                                                        <IconButton aria-label="delete" onClick={() => DialogOpenClick(1, r)} hidden={getOrgType() == "Client"}>
                                                            <img src={Replay} alt="Replay" />
                                                        </IconButton>
                                                    </StyledTableCell>
                                                    <StyledTableCell sx={{ width: "10%" }}>
                                                        <IconButton aria-label="delete" onClick={() => DialogOpenClick(2, r)} hidden={getOrgType() == "Client"}>
                                                            <img src={Trash} alt="trashicon" />
                                                        </IconButton>
                                                    </StyledTableCell>
                                                </TableRow>

                                            </TableBody>
                                        ))}
                                    </Table>

                                </TableContainer>
                            </>
                        }
                    </>
                </Box >

            </Card>
            <div hidden={Count < 1}>
                <Paginator
                    count={Math.ceil(Count / 12)}
                    page={Number(number)}
                    margin="18px 0px"
                    onChange={handlePageChange}
                />
            </div>


        </Box >
    );
}





